import { useRef, useState } from "react";
import { useIsUserSignedIn } from "../../core_stores/useAuthStore";
import { debugLog } from "../../utils/logUtils";
import { useProjectName } from "../../view_stores/useProjectConfigStore";
import {
  PreviewUrlStatus,
  useProjectPreviewStatus,
  useProjectPreviewUrl,
} from "../../view_stores/useProjectPreviewStore";
import {
  SideMenuBehavior,
  useSideMenuBehavior,
} from "../../view_stores/useSideMenuStore";
import { SplitPanel } from "../common_components/SplitPanel";
import SideMenuPanel from "../sideMenu/SideMenuPanel";
import { ProjectChat } from "./components/ProjectChat";
import { ProjectDashboard } from "./components/ProjectDashboard";
import ProjectDashboardTopPanel from "./components/ProjectDashboardTopPanel";

export function ProjectPageDefault() {
  const isUserSignedIn = useIsUserSignedIn();
  const sideMenuBehavior = useSideMenuBehavior();
  const projectName = useProjectName();
  const previewUrl = useProjectPreviewUrl();
  const previewStatus = useProjectPreviewStatus();
  const [panelWidth, setPanelWidth] = useState<number>(0);
  const containerRef = useRef<HTMLDivElement>(null);

  // DEBUG: Track when projectName or previewUrl changes
  debugLog(
    `[DEBUG ${new Date().toISOString()}] ProjectPageDefault render - projectName:`,
    projectName,
    "previewUrl:",
    previewUrl,
    "previewStatus:",
    previewStatus
  );

  const isDisabled =
    !projectName || previewStatus === PreviewUrlStatus.NotAvailable;

  // Callback to receive width updates from SplitPanel
  const handlePanelWidthChange = (pixelWidth: number) => {
    setPanelWidth(pixelWidth);
  };

  return (
    <div className="h-[100dvh] min-h-[650px] w-full bg-dark-surface-primary flex flex-col">
      {isUserSignedIn && <SideMenuPanel />}
      <div
        className={`${
          isUserSignedIn &&
          (sideMenuBehavior === SideMenuBehavior.PINNED
            ? "pl-[320px]"
            : "pl-[60px]")
        } flex-1 overflow-hidden transition-[padding] duration-300 flex flex-col`}
      >
        <ProjectDashboardTopPanel
          isDisabled={isDisabled}
          panelWidth={panelWidth}
        />
        <div ref={containerRef} className="flex-1 overflow-hidden">
          <SplitPanel
            leftChild={<LeftColumn />}
            rightChild={<ProjectDashboard />}
            minLeftChildWidth={300}
            minRightChildWidth={300}
            initialLeftChildWidth={30}
            onWidthChange={handlePanelWidthChange}
          />
        </div>
      </div>
    </div>
  );
}

function LeftColumn() {
  return (
    <div className="h-full w-full">
      <ProjectChat />
    </div>
  );
}
